<template>
  <div class="user-details">
    <div class="user-details__dialog text-center">
      <div class="user-details__company">
        <img class="user-details__company-logo" src="~assets/img/company.svg">
        <h1 class="user-details__company-name">
          {{ companyName }}
        </h1>
      </div>
      <div class="user-details__form">

        <div class="user-details__form-line">
          <label class="user-details__form-label">Please enter your role:</label>
          <input class="user-details__form-input" value="" v-model="respondent.role" placeholder="Type role">
        </div>

        <div class="user-details__form-line">
          <label class="user-details__form-label">Please select your function.
            If your function is not listed,<br>select “Other” and type in the free text field</label>
          <select v-if="showSelect"  @change="hideSelect"
            class="user-details__form-select" v-model="respondent.function"
            :class="{'option-selected': respondent.function !== 'empty' && respondent.function !== ''}">
            <option value="empty" disabled>Select function</option>
            <option v-for="functionName in respondentFunctions" :key="functionName.id">{{ functionName }}</option>
            <option value="other">Other: Specify ____</option>
          </select>
          <div v-else class="position-relative">
            <input class="user-details__form-input" v-model="respondent.function">
            <span @click="hideInput" class="user-details__close-btn">x</span>
          </div>
        </div>

        <div class="user-details__form-line">
          <label class="user-details__form-label">Please select your region:</label>
          <select class="user-details__form-select" v-model="respondent.region"
            :class="{'option-selected': respondent.region !== 'empty' && respondent.region !== ''}">
            <option value="empty" disabled>Select region</option>
            <option v-for="location in respondentLocations" :key="location.id">{{ location }}</option>
          </select>
        </div>

        <p class="user-details__description">This information will remain anonymous
          and will never be shown or shared</p>
        <button @click="createRespondent" class="custom-btn custom-btn--green"
          :disabled="disableSubmit">
          Accept
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// API
import organizationsApi from '@/api/organizations';
import respondentsApi from '@/api/respondents';

export default {
  data() {
    return {
      respondentFunctions: ['R&D', 'Sales', 'Commercial', 'Customer Service', 'Operations', 'Marketing',
        'Finance', 'HR', 'Procurement', 'IT', 'Regulation', 'Health & Safety', 'Legal', 'Facilities'],
      respondentLocations: ['North America', 'South America', 'Europe (excl. UK)', 'Middle East & North Africa',
        'Sub-Saharan Africa', 'Asia (excl. Hong Kong & Greater China)', 'Australia', 'UK', 'Hong Kong & Greater China',
        'New Zealand & Pacific'],
      respondent: {
        role: '',
        function: 'empty',
        region: 'empty',
      },
      companyName: '',
      processing: false,
      showSelect: true,
    };
  },
  methods: {
    createRespondent() {
      this.processing = true;
      respondentsApi.create({ respondent: this.respondent, evaluation_code: this.$route.params.id })
        .then((response) => {
          this.processing = false;
          respondentsApi.setAuthHeaders(response);
          localStorage.setItem('Authorization', response.data.auth_token);
          localStorage.setItem('CurrentEvaluation', this.$route.params.id);
          localStorage.setItem('CompletedSections', 0);
          this.$router.push({ name: 'sections' });
        }).catch(() => {
          this.processing = false;
        });
    },
    hideSelect() {
      if (this.respondent.function === 'other') {
        this.showSelect = false;
        this.respondent.function = '';
      }
    },
    hideInput() {
      this.showSelect = true;
      this.respondent.function = 'empty';
    },
  },
  computed: {
    disableSubmit() {
      return (this.respondent.role === '' || this.respondent.function === '' || this.respondent.region === ''
        || this.respondent.function === 'empty' || this.respondent.region === 'empty');
    },
  },
  created() {
    organizationsApi.validate({ evaluation_code: this.$route.params.id })
      .then((response) => {
        this.companyName = response.data.organization.name;
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/UserDetails.vue